<template>
    <div>
        <v-btn color="main--yellow" depressed dark class="mb-3 px-4" @click="contractDialog = true">{{ $t('addContract') }}</v-btn>
        <v-dialog
                v-model="contractDialog"
                width="600"
                hide-overlay
                transition="dialog-bottom-transition"
        >
            <v-toolbar flat dark class="main--yellow">
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-spacer></v-spacer>
                    <v-btn text @click.native="contractDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card>
                <v-form
                        ref="form"
                        lazy-validation
                        v-model="isValidOrder"
                >
                    <div class="d-flex justify-center title pa-4 text-center">{{ $t('addContract') }}</div>
                    <v-card-text>
                        <v-row сlass="pb-4">
                            <v-col cols="12" sm="12">
                                <v-text-field
                                        :label="$t('name')"
                                        v-model="contractModel.name"
                                        color="orange lighten-2"
                                        :rules="rules"
                                        required
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-file-input
                                        :label="$t('selectFile')"
                                        v-model="contractModel.file"
                                        color="orange lighten-2"
                                        prepend-icon=""
                                        accept=".doc,.docx,.xls,.xlsx,.pdf,.txt"
                                        :rules="rules"
                                        required
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <div class="d-flex justify-center pb-6">
                        <v-btn depressed color="main--yellow" class="test-white" @click="saveChanges" :disabled="!isValidOrder">
                            {{ $t('save') }}
                        </v-btn>
                    </div>
                </v-form>
            </v-card>
        </v-dialog>
        <snack-general :snack-data="snackData"></snack-general>
    </div>
</template>

<script>

    import ContractService from '../../../app-front/services/api/ContractsService';
    import SnackGeneral from '../snacks/SnackGeneral';

    export default {
        name: "ContractCreateDialog",
        components:{SnackGeneral},
        data() {
            return {
                validated: false,
                contractDialog: false,
                contractModel: {
                    name: null,
                    file: null,
                },
                contractFile: null,
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                },
                isValidOrder: false,
                rules: [v => !!v || this.$t('requiredField')],
            }
        },
        methods: {
            saveChanges() {
                if (this.$refs.form.validate()) {
                    const params = new FormData();
                    params.append('title', this.contractModel.name);
                    params.append('file', this.contractModel.file);

                    ContractService.createContract(params)
                        .then(res => {
                            this.snackHandle(this.$t('contractAdded'), 'main--black', true);
                            this.contractModel.name = null;
                            this.contractModel.file = null;
                            this.$emit('value-change', true);
                            this.contractDialog = false;
                        })
                        .catch(err => {
                            this.snackHandle(this.$t('changesSavedError'), 'error', true);
                            console.log(err);
                        })
                }

            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
        }
    }
</script>

<style scoped>
    #fl_inp {
        display:none;
    }
    .fl_upld label {
        cursor: pointer;
        padding: 10px 25px;
        color: #F5B821;
        text-align: center;
    }
</style>